import React from "react";

import { SonicDBEntry } from "../../common/classes/SonicDBEntry";
import SonicTeam from "../../common/classes/SonicTeam";
import { SonicProject } from "../../common/classes/SonicProject";
import { SonicEvent } from "../../common/classes/SonicEvent";
import DBListItem from "../../common/db-list/DBListItem";

import ProjectListItem from "../project-list/ProjectListItem";
import EventSwiperItem from "../top/event/EventSwiperItem";

import {
  genTermNames,
  getLargestImage,
  getDefaultImage,
  timestampToTime,
} from "../../utils/GeneralUtils";

import styles from "./UserDetail.module.scss";
import { SonicTopics } from "../../common/classes/SonicTopics";
import TopicsListItem from "../top/topics/TopicsListItem";

type Props = {
  username?: string;
  profiles?: Array<SonicDBEntry>;
  teams?: Array<SonicTeam>;
  projects?: Array<SonicProject>;
  events?: Array<SonicEvent>;
  topics?: Array<SonicTopics>;
};

const UserDetail: React.FC<Props> = ({
  username,
  profiles,
  teams,
  projects,
  events,
  topics,
}) => {
  return (
    <div className={styles["f-userDetail"]}>
      <div className={styles["f-userDetail__wrapper"]}>
        <div className={styles["f-userDetail__name"]}>
          <span>会員名</span>
          <p>{username}</p>
        </div>
        <div className={styles["f-userDetail__list"]}>
          <h2 className={styles["f-userDetail__title"]}>プロフィール</h2>
          {profiles && profiles.length > 0 ? (
            <div className={styles["f-userDetail__list-wrapper"]}>
              {profiles.map((profile) => (
                <DBListItem
                  key={profile.id}
                  to={`/person/${profile.id}`}
                  tags={
                    profile.player_type
                      ? genTermNames(profile.player_type)
                      : undefined
                  }
                  name={profile.name}
                  img_src={profile.imgs?.[0]?.medium?.url}
                  isStudent={profile.school ? true : false}
                />
              ))}
            </div>
          ) : (
            <div className={styles["f-userDetail__list-empty"]}>
              このコンテンツはまだ登録されていません。
            </div>
          )}
        </div>
        <div className={styles["f-userDetail__list"]}>
          <h2 className={styles["f-userDetail__title"]}>チーム</h2>
          {teams && teams.length > 0 ? (
            <div className={styles["f-userDetail__list-wrapper"]}>
              {teams.map((team) => (
                <DBListItem
                  key={team.id}
                  to={`/team/${team.id}`}
                  img_src={
                    team.term !== null
                      ? team.term.img?.thumbnail.url
                      : undefined
                  }
                  team_color={team.term !== null ? team.term.color : undefined}
                  {...team}
                />
              ))}
            </div>
          ) : (
            <div className={styles["f-userDetail__list-empty"]}>
              このコンテンツはまだ登録されていません。
            </div>
          )}
        </div>
        <div className={styles["f-userDetail__list"]}>
          <h2 className={styles["f-userDetail__title"]}>プロジェクト</h2>
          {projects && projects.length > 0 ? (
            <div
              className={`${styles["f-userDetail__list-wrapper"]} ${styles["threeColumn"]}`}
            >
              {projects.map((project) => (
                <ProjectListItem
                  key={project.id}
                  id={project.id}
                  name={project.name}
                  type={project.type}
                  imgs={project.imgs}
                  applicants={project.applicants}
                  end_date={project.end_date}
                  owner={project.owner_name}
                  isJikei={
                    project.role_restriction.includes("jikei_student")
                      ? true
                      : false
                  }
                  isGridLayout={true}
                />
              ))}
            </div>
          ) : (
            <div className={styles["f-userDetail__list-empty"]}>
              このコンテンツはまだ登録されていません。
            </div>
          )}
        </div>
        <div className={styles["f-userDetail__list"]}>
          <h2 className={styles["f-userDetail__title"]}>イベント</h2>
          {events && events.length > 0 ? (
            <div
              className={`${styles["f-userDetail__list-wrapper"]} ${styles["threeColumn"]}`}
            >
              {events.map((event) => (
                <EventSwiperItem
                  key={event.id}
                  id={event.id}
                  title={event.name}
                  type={event.event_type}
                  img={
                    event.imgs?.length > 0
                      ? getLargestImage(event.imgs[0])
                      : getDefaultImage()
                  }
                  isJikei={
                    event.role_restriction.includes("jikei_student")
                      ? true
                      : false
                  }
                />
              ))}
            </div>
          ) : (
            <div className={styles["f-userDetail__list-empty"]}>
              このコンテンツはまだ登録されていません。
            </div>
          )}
        </div>
        <div className={styles["f-userDetail__list"]}>
          <h2 className={styles["f-userDetail__title"]}>トピックス</h2>
          {topics && topics.length > 0 ? (
            <div
              className={`${styles["f-userDetail__list-wrapper"]} ${styles["threeColumn"]}`}
            >
              {topics.map((topic) => (
                <TopicsListItem
                  key={topic.id}
                  to={topic.id}
                  category={topic.topic_type?.name}
                  date={timestampToTime(topic.start_date, false, false, ".")}
                  title={topic.name}
                  author={topic.author_name}
                  img_src={getLargestImage(topic.imgs?.[0])}
                  tags={topic.tags}
                />
              ))}
            </div>
          ) : (
            <div className={styles["f-userDetail__list-empty"]}>
              このコンテンツはまだ登録されていません。
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserDetail;
